import { type KeyboardEvent } from 'react'
import classnames from 'classnames'

import { type FileBrowserItem } from './types'
import { formatSizeColumn, formatUpdated, getFileIconClass } from './utils'
import { FileBrowserRowTrailing } from './FileBrowserRowTrailing'
import styles from './FileBrowser.module.scss'

interface FileBrowserRowProps {
  item: FileBrowserItem
  isSelected: boolean
  isDisabled: boolean
  showCheckboxes: boolean
  isFolderSelectable: boolean
  isFileSelectable: boolean
  checkType: 'radio' | 'checkbox'
  onRowClick: (item: FileBrowserItem) => void
  onRowDoubleClick: (item: FileBrowserItem) => void
  onSelect: (itemId: string) => void
  onOpenFolder: (folderId: string, folderName: string) => void
}

export const FileBrowserRow = ({
  item,
  isSelected,
  isDisabled,
  showCheckboxes,
  isFolderSelectable,
  isFileSelectable,
  checkType,
  onRowClick,
  onRowDoubleClick,
  onSelect,
  onOpenFolder,
}: FileBrowserRowProps) => {
  const isFolder = item.type === 'folder'

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onRowClick(item)
    }
  }

  return (
    <div
      className={classnames(styles.row, {
        [styles.rowSelected]: isSelected,
        [styles.rowDisabled]: isDisabled,
      })}
      onClick={isDisabled ? undefined : () => onRowClick(item)}
      onDoubleClick={isDisabled ? undefined : () => onRowDoubleClick(item)}
      role={isDisabled ? undefined : 'button'}
      tabIndex={isDisabled ? -1 : 0}
      onKeyDown={isDisabled ? undefined : handleKeyDown}
    >
      <i className={classnames('bi', 'flex-shrink-0', isFolder ? 'bi-folder-fill zocks-text-primary' : getFileIconClass(item.name))} />

      <span className={styles.itemName}>{item.name}</span>

      <span className={classnames(styles.itemMeta, styles.colUpdated, 'paragraph-small')}>{formatUpdated(item)}</span>
      <span className={classnames(styles.itemMeta, styles.colSize, 'paragraph-small')}>{formatSizeColumn(item)}</span>

      <FileBrowserRowTrailing
        item={item}
        isSelected={isSelected}
        showCheckboxes={showCheckboxes}
        isFolderSelectable={isFolderSelectable}
        isFileSelectable={isFileSelectable}
        checkType={checkType}
        onSelect={onSelect}
        onOpenFolder={onOpenFolder}
      />
    </div>
  )
}
